import React, { useEffect, useState } from "react";
import { Button, Row, Col, Nav, Card, FormGroup, Input } from "reactstrap";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { approveVerification } from "../../../service/user-verification-service";
import {
  rejectVerification,
  getrejectReason,
} from "../../../service/user-verification-service";
import { message } from "antd";
import Select from "react-select";
import Loading from "../../loader/loader";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../common/notification-message/notification";

function ApproveConformation(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>Do you want to verify and activate the card?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          No
        </Button>
        <Button
          variant="primary"
          color="primary"
          onClick={props.onClickChange}
          disabled={props.buttonloading === true ? true : false}
        >
          {props.buttonloading ? (
            <Loading color="white" width="15px" height="15px" />
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function RejectedConformation(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to reject the user?
        {/* <div style={{ margin: "5% 0", display: "flex" }}>
          <FormGroup style={{ paddingTop: "8px" }}>
            <label style={{ paddingRight: "20px" }}>Reason :</label>
          </FormGroup>
          <div style={{ width: "75%" }}>
            <Input
              id="exampleFormControlSelect1"
              type="select"
              placeholder="Reason For Reject"
              value={props.reason}
              onChange={props.handleReason}
              name="reason"
            >
              {props.rejectReasonOptions &&
                props.rejectReasonOptions &&
                props.rejectReasonOptions.map((reasons) => (
                  <option value={reasons.id}>{reasons.name}</option>
                ))}
            </Input>
          </div>
        </div> */}
        <div style={{ margin: "5% 0", display: "flex" }}>
          <FormGroup style={{ paddingTop: "8px" }}>
            <label style={{ paddingRight: "20px" }}>Reason :</label>
          </FormGroup>
          <div style={{ width: "75%" }}>
            <Select
              placeholder="Reason For Reject"
              onChange={props.handleReason}
              options={props.rejectReasonOptions.map((e) => ({
                label: e.name,
                value: e.id,
              }))}
              value={props.reason}
            />
          </div>{" "}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          No
        </Button>
        <Button
          variant="primary"
          color="primary"
          onClick={props.onClickChange}
          disabled={!props.reasonId || props.buttonloading}
        >
          {props.buttonloading ? (
            <Loading color="white" width="15px" height="15px" />
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const RegistraionHeader = ({ registrationObject, title, registrationType }) => {
  const [faceColor, setFaceColor] = useState("#d3455b");
  const [nameColor, setNameColor] = useState("#d3455b");
  const [approve, setApprove] = useState(false);
  const [approve1, setApprove1] = useState("");
  const [rejected, setRejected] = useState("");
  const [rejected1, setRejected1] = useState("");
  const history = useHistory();
  const [buttonloading, setButtonloading] = useState(false);
  const [reason, setReason] = useState([]);
  const [reasonId, setReasonId] = useState(null);
  const [rejectReasonOptions, setRejectReasonOptions] = useState([]);

  useEffect(() => {
    let faceMatch =
      (registrationObject && registrationObject.faceMatchPercentage) || 0;
    if (faceMatch > 59 && faceMatch <= 100) {
      setFaceColor("#1aae9f");
    } else if (faceMatch > 29 && faceMatch <= 59) {
      setFaceColor("#f7c325");
    } else {
      setFaceColor("#d3455b");
    }
  }, [registrationObject && registrationObject.faceMatchPercentage]);

  useEffect(() => {
    let nameMatch =
      (registrationObject && registrationObject.nameMatchPercentage) || 0;
    if (nameMatch > 74 && nameMatch <= 100) {
      setNameColor("#1aae9f");
    } else if (nameMatch > 39 && nameMatch <= 74) {
      setNameColor("#f7c325");
    } else {
      setNameColor("#d3455b");
    }
  }, [registrationObject && registrationObject.nameMatchPercentage]);

  useEffect(() => {
    const reject = async () => {
      let reasonRes = await getrejectReason();
      setRejectReasonOptions(reasonRes.data);
    };
    reject();
  }, []);

  const handleapprovechange = () => {
    setApprove(false);
    setApprove1(false);
    history.push("/admin/registrations");
  };

  const handlerejectedchange = () => {
    setRejected(false);
    setRejected1(false);
    history.push("/admin/registrations");
  };
  const handleReason = (selectedOption) => {
    setReason(selectedOption);
    setReasonId(selectedOption.value);
  };

  const verifyAndActiveCard = (id) => {
    if (id) {
      setButtonloading(true);
      approveVerification(id)
        .then((approveVerificationRes) => {
          setButtonloading(false);
          setApprove(false);
          // setApprove1(true);
          openNotificationWithIcon(
            notificationStrings.success,
            "Verified and activate card successfully"
          );
          // message.success("Verified and activate card successfully");
          history.push("/admin/verifications");
        })
        .catch((approveVerificationerr) => {
          setButtonloading(false);
          setApprove(false);
          // setApprove1(false);
          // message.error('Something went wrong');
        });
    }
  };

  const rejectRegistration = (emiratesIdUpdateId) => {
    if (emiratesIdUpdateId) {
      setButtonloading(true);
      rejectVerification(emiratesIdUpdateId, reasonId)
        .then((rejectVerificationRes) => {
          setButtonloading(false);
          setRejected(false);
          // setRejected1(true);
          // message.success("Rejected successfully");
          openNotificationWithIcon(
            notificationStrings.success,
            "Rejected successfully"
          );
          history.push("/admin/verifications");
        })
        .catch((rejectVerificationerr) => {
          setRejected(false);
          // setRejected1(false);
          // message.error(rejectVerificationerr);
          setButtonloading(false);
        });
    }
  };

  return (
    <>
      <Card>
        <footer>
          <Row className="align-items-center justify-content-lg-between">
            <Col lg="12">
              <Nav className=" justify-content-center justify-content-lg-end align-items-center">
                <h3
                  className="mb-0"
                  style={{ marginRight: 15, color: "black" }}
                >
                  Face match ={" "}
                  <span style={{ color: faceColor }}>
                    {(registrationObject &&
                      registrationObject.faceMatchPercentage) ||
                      0}{" "}
                    %
                  </span>
                </h3>
                <h3
                  className="mb-0"
                  style={{ marginRight: 15, color: "black" }}
                >
                  Name match ={" "}
                  <span style={{ color: nameColor }}>
                    {(registrationObject &&
                      registrationObject.nameMatchPercentage) ||
                      0}{" "}
                    %
                  </span>
                </h3>
                {title === "Verifications" && registrationType !== "NoKYC" && (
                  <Button
                    color="primary"
                    type="button"
                    style={{ height: "30px", margin: "10px 5px" }}
                    onClick={() => setApprove(true)}
                  >
                    Verify and activate card
                  </Button>
                )}
                {title === "Verifications" && registrationType !== "NoKYC" && (
                  <Button
                    color="pinterest"
                    type="button"
                    style={{ height: "30px", margin: "10px 5px" }}
                    onClick={() => setRejected(true)}
                  >
                    Reject registration
                  </Button>
                )}
              </Nav>
            </Col>
          </Row>
        </footer>
        <ApproveConformation
          show={approve}
          onHide={() => setApprove(false)}
          onClickChange={() => {
            verifyAndActiveCard(
              registrationObject && registrationObject.emiratesIdUpdateId
            );
          }}
          buttonloading={buttonloading}
        />

        <RejectedConformation
          show={rejected}
          rejectReasonOptions={rejectReasonOptions}
          handleReason={handleReason}
          reason={reason}
          reasonId={reasonId}
          onHide={() => {
            setRejected(false);
            setReason([]);
            setReasonId("");
          }}
          onClickChange={() => {
            rejectRegistration(registrationObject.emiratesIdUpdateId);
          }}
          buttonloading={buttonloading}
        />
      </Card>
    </>
  );
};

export default RegistraionHeader;
